import Utils from '../Utils';

/* eslint-disable no-undef */
export default class Analytics {
	static onZip = () => {
		gtag('event', 'click', { event_category: 'zip' });
		gtag_report_conversion();
	}
	static onFolderUpload = () => {
		gtag('event', 'click', { event_category: 'upload-folder', });
	}
	static onDownLoadAll = () => {
		gtag('event', 'click', { event_category: 'download-all', });
		gtag_report_conversion();
	}

	static onThumbsUp = () => {
		gtag('event', 'click', {
			event_category: 'download-all-feedback',
			event_label: `Ok ${Utils.getBrowserVersion()}` });
	}

	static onThumbsDown = () => {
		gtag('event', 'click', {
			event_category: 'download-all-feedback',
			event_label: `Not Ok ${Utils.getBrowserVersion()}` });
	}

	static onShowHelp = () => {
		gtag('event', 'click', {
			event_category: 'download-all-help',
			event_label: Utils.getBrowserVersion() });
	}

	static onFileDownload = () => {
		gtag('event', 'click', { event_category: 'file-download' });
		gtag_report_conversion();
	}

	static onBookmark = () => {
		gtag('event', 'keypress', { event_category: 'bookmark' });
	}

	static onRecompress = () => {
		gtag('event', 'action', { event_category: 'recompress' });
	}

	static onCompressToSize = () => {
		gtag('event', 'action', { event_category: 'compress-to-size' });
	}
}



// WEBPACK FOOTER //
// ./src/services/Analytics.js